import {
  Heart,
  MessageCircle,
  Bookmark,
  Send,
  Music2,
  Home,
  Search,
  Plus,
  Inbox,
  User,
} from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot, MediaCarousel } from "./PreviewShell";

export function TikTokPreview(props: PreviewProps) {
  return (
    <PreviewShell device={props.device}>
      <div className="bg-black text-white relative" style={{ aspectRatio: "9 / 16" }}>
        <div className="absolute inset-0">
          {props.mediaUrls && props.mediaUrls.length > 1 ? (
            <MediaCarousel
              mediaUrls={props.mediaUrls}
              aspect="h-full"
              bgClass="bg-black"
              fallback={<span className="text-white/60 text-xs">Media not available</span>}
            />
          ) : (
            <MediaSlot
              mediaUrl={props.mediaUrl}
              mediaType={props.mediaType}
              aspect="h-full"
              bgClass="bg-black"
              fallback={<span className="text-white/60 text-xs">Video not available</span>}
            />
          )}
        </div>
        <div className="absolute top-3 left-0 right-0 flex justify-center gap-6 text-[12px] text-white/80 font-medium">
          <span>Following</span>
          <span className="text-white">For you</span>
        </div>
        <div className="absolute right-2 bottom-24 flex flex-col items-center gap-3.5">
          <div className="w-9 h-9 rounded-full bg-red-500 flex items-center justify-center">
            {props.pageAvatarUrl ? (
              <img
                src={props.pageAvatarUrl}
                alt=""
                className="w-full h-full rounded-full object-cover"
              />
            ) : (
              <span className="text-[10px] font-bold">
                {props.pageName.slice(0, 2).toUpperCase()}
              </span>
            )}
          </div>
          <div className="flex flex-col items-center text-[10px]">
            <Heart size={22} fill="white" />
            <span>0</span>
          </div>
          <div className="flex flex-col items-center text-[10px]">
            <MessageCircle size={22} fill="white" />
            <span>0</span>
          </div>
          <div className="flex flex-col items-center text-[10px]">
            <Bookmark size={22} fill="white" />
            <span>0</span>
          </div>
          <div className="flex flex-col items-center text-[10px]">
            <Send size={22} fill="white" />
            <span>0</span>
          </div>
        </div>
        <div className="absolute left-3 right-16 bottom-14 text-[12px]">
          <div className="font-semibold">{props.pageName}</div>
          {props.caption && (
            <p className="mt-1 line-clamp-2 text-[11px] leading-snug">{props.caption}</p>
          )}
          <div className="flex items-center gap-1 mt-1.5 text-[11px]">
            <Music2 size={11} /> Original Sound
          </div>
        </div>
        <div className="absolute left-0 right-0 bottom-0 flex items-center justify-around py-2 bg-black/85 text-[9px]">
          <span className="flex flex-col items-center gap-0.5">
            <Home size={16} /> Home
          </span>
          <span className="flex flex-col items-center gap-0.5">
            <Search size={16} /> Friends
          </span>
          <span className="bg-white text-black w-8 h-5 rounded flex items-center justify-center">
            <Plus size={12} />
          </span>
          <span className="flex flex-col items-center gap-0.5">
            <Inbox size={16} /> Inbox
          </span>
          <span className="flex flex-col items-center gap-0.5">
            <User size={16} /> Profile
          </span>
        </div>
      </div>
    </PreviewShell>
  );
}
